/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './receipt.tpl.html';

angular
  .module('receipts.receipt', [])
  /**
   * Controller for the receipts.receipt template.
   */
  .controller('ReceiptsReceiptCtrl', function ($scope, $state, receiptMarkup, VIEW_STATES) {
    $scope.receiptMarkup = receiptMarkup;

    /**
     * Handler for returning to the receipt list.
     */
    $scope.goList = function () {
      $state.go(VIEW_STATES.RECEIPTS_CONTENT_LIST);
    };
  });
